import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from '../locales/en/translation.json';
import huTranslation from '../locales/hu/translation.json';
import { LANGUAGE_STORAGE_KEY, normalizeLanguage } from './locales';

function getInitialLanguage() {
	const storedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY);
	if (storedLanguage) {
		return normalizeLanguage(storedLanguage);
	}

	return normalizeLanguage(navigator.language);
}

if (!i18n.isInitialized) {
	i18n.use(initReactI18next).init({
		lng: getInitialLanguage(),
		fallbackLng: 'hu',
		resources: {
			hu: {
				translation: huTranslation
			},
			en: {
				translation: enTranslation
			}
		},
		interpolation: {
			escapeValue: false
		}
	});

	document.documentElement.lang = i18n.resolvedLanguage || 'hu';

	i18n.on('languageChanged', (language) => {
		const normalizedLanguage = normalizeLanguage(language);
		localStorage.setItem(LANGUAGE_STORAGE_KEY, normalizedLanguage);
		document.documentElement.lang = normalizedLanguage;
	});
}

export default i18n;